import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class BatchJobHistory extends AbstractModel {
  @autoserialize
  fileName: string;

  @autoserialize
  personFullName: string;

  @autoserializeAs(Date)
  startedDate: Date;

  @autoserializeAs(Date)
  completedDate: Date;

  @autoserialize
  recordCount: number;

  @autoserialize
  type: string;

  @autoserialize
  status: string;

  static OnSerialized(instance: BatchJobHistory, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.startedDate)) {
      json.startedDate = DateUtil.serializeInstant(instance.startedDate);
    }

    if (!isNullOrUndefined(instance.completedDate)) {
      json.completedDate = DateUtil.serializeInstant(instance.completedDate);
    }
  }

  static OnDeserialized(instance: BatchJobHistory, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['startedDate'])) {
      instance.startedDate = DateUtil.deserializeInstant(json['startedDate']);
    }

    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeInstant(json['completedDate']);
    }
  }
}
